import { jsx as C } from "react/jsx-runtime";
import { ROTATE_PAGINATION_CONVERSION as e } from "./index.es2479.js";
import { ICONS_COLOR_MAPPING as i } from "./index.es2447.js";
const a = ["start", "end"], d = ({
  direction: n = "forward",
  size: t = 12,
  testId: r,
  color: l = "default-gray"
}) => {
  const o = e[n] ? { transform: `rotate(${e[n]}deg)` } : {};
  return a.includes(n) ? /* @__PURE__ */ C(
    "svg",
    {
      "data-testid": r,
      width: t,
      height: t,
      style: o,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.56954 4.12837C9.36429 4.31311 9.34767 4.62926 9.53241 4.8345L12.8317 8.5L9.53241 12.1655C9.34767 12.3708 9.36429 12.6869 9.56954 12.8716C9.77478 13.0564 10.0909 13.0398 10.2757 12.8345L13.8722 8.83878C13.9066 8.8015 13.9344 8.76008 13.9554 8.71613C13.9882 8.6478 14.0044 8.57382 14.0044 8.5C14.0044 8.42619 13.9882 8.35221 13.9554 8.28388C13.9344 8.23993 13.9066 8.19851 13.8722 8.16123L10.2757 4.1655C10.0909 3.96026 9.77478 3.94363 9.56954 4.12837ZM4.16899 4.12837C3.96374 4.31311 3.94712 4.62926 4.13186 4.8345L7.43113 8.5L4.13186 12.1655C3.94712 12.3708 3.96374 12.6869 4.16899 12.8716C4.37423 13.0564 4.69038 13.0398 4.87512 12.8345L8.47162 8.83878C8.50605 8.8015 8.53382 8.76008 8.55486 8.71613C8.58764 8.6478 8.60387 8.57382 8.60384 8.5C8.60387 8.42619 8.58764 8.35221 8.55486 8.28388C8.53382 8.23993 8.50605 8.19851 8.47162 8.16123L4.87512 4.1655C4.69038 3.96026 4.37423 3.94363 4.16899 4.12837Z",
          fill: i[l]
        }
      )
    }
  ) : /* @__PURE__ */ C(
    "svg",
    {
      width: t,
      height: t,
      style: o,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M7.14645 5.85355C6.95118 5.65829 6.95118 5.34171 7.14645 5.14645C7.34171 4.95118 7.65829 4.95118 7.85355 5.14645L11.8536 9.14645C12.0488 9.34171 12.0488 9.65829 11.8536 9.85355L7.85355 13.8536C7.65829 14.0488 7.34171 14.0488 7.14645 13.8536C6.95118 13.6583 6.95118 13.3417 7.14645 13.1464L10.7929 9.5L7.14645 5.85355Z",
          fill: i[l]
        }
      )
    }
  );
};
d.__tags = ["pagination"];
export {
  d as UtilityPaginationIcon
};
//# sourceMappingURL=index.es455.js.map
